import UserRoleEnum from '@constants/enums/user/role';

const FundManagerRoleEnum = Object.freeze({
    SUPERUSER: UserRoleEnum.SUPERUSER,
    FUND_MANAGER_AUDITOR: UserRoleEnum.FUND_MANAGER_AUDITOR
});

export default FundManagerRoleEnum;
